import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { URLS } from 'src/app/constants/URLS';
declare let shaka: any | undefined;
declare var window: any | undefined;
@Component({
  selector: 'app-downlaodnplayback',
  templateUrl: './downlaodnplayback.component.html',
  styleUrls: ['./downlaodnplayback.component.css']
})
export class DownlaodnplaybackComponent  implements AfterViewInit {
  @ViewChild('asseturiinput') asseturiinput: ElementRef | undefined;
  @ViewChild('assettitleinput') assettitleinput: ElementRef | undefined;
  @ViewChild('downloadButton') downloadButton: ElementRef | undefined;
  @ViewChild('progressBar') progressbar: ElementRef | undefined;
  @ViewChild('contenttable') contenttable: ElementRef | undefined;
  @ViewChild('video') video: ElementRef | undefined;

    
  mpd_fileName:string;
  title:string;
  userId:Number;
  channelId:number;
  vidLibId:number;
  videoType:String;
  mediaUrl: String = URLS.BASE_URL + '/static/post_videos/';

  constructor(private toastr: ToastrService, private route: ActivatedRoute) { 
    document.addEventListener('DOMContentLoaded', this.initApp);

  }

  ngAfterViewInit(): void {  
    this.initPlayer();
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.mpd_fileName = params['fileName'];
      this.title=params['title'];
      this.channelId= params['channelId'];
      this.vidLibId=  params['vidLibId'];
      this.videoType= params['videoType'];
      this.userId=167;
    });
  }
   initApp() {
    // Install built-in polyfills to patch browser incompatibilities.
    shaka.polyfill.installAll();
  
    // Check to see if the browser supports the basic APIs Shaka needs.
    if (shaka.Player.isBrowserSupported()) {
      // Everything looks good!
      this.initPlayer();
    } else {
      // This browser does not have the minimum set of APIs we need.
      console.error('Browser not supported!');
    }
  
    // Update the online status and add listeners so that we can visualize
    // our network state to the user.
    this.updateOnlineStatus();
    window.addEventListener('online',  this.updateOnlineStatus);
    window.addEventListener('offline', this.updateOnlineStatus);
  }
  
   public initPlayer() {
    console.log("initPlayer method called")
    // Create a Player instance.
    const video =  this.video.nativeElement; 
    // document.getElementById('video'); 
    const player = new shaka.Player(video);
    player.configure({
      drm: {
        servers: { 
       //   'com.widevine.alpha': 'https://widevine-dash.ezdrm.com/proxy?pX=C487BC&userId=167&channelId=43&vidLibId=10830&videoType=FREE'
       'com.widevine.alpha': "https://widevine-dash.ezdrm.com/proxy?pX=C487BC&userId="+this.userId+"&channelId="+this.channelId+"&vidLibId="+this.vidLibId+"&videoType="+this.videoType
 
      }
      }
    });
    // Attach player and storage to the window to make it easy to access
    // in the JS console and so we can access it in other methods.
    window.player = player;
  
    // Listen for error events.
    player.addEventListener('error', this.onErrorEvent);
  
    this.initStorage(player);
  
   // const downloadButton = this.downloadButton.nativeElement;
   // downloadButton.onclick = this.onDownloadClick;
  
    // Update the content list to show what items we initially have
    // stored offline.
    this.refreshContentList();
  }
  
   onErrorEvent(event) {
    // Extract the shaka.util.Error object from the event.
    this.onError(event.detail);
  }
  
   onError(error) {
    // Log the error.
    console.error('Error code', error.code, 'object', error);
  }
  
   selectTracks(tracks) {
    // This example stores the highest bandwidth variant.
    //
    // Note that this is just an example of an arbitrary algorithm, and not a best
    // practice for storing content offline.  Decide what your app needs, or keep
    // the default (user-pref-matching audio, best SD video, all text).
    const found = tracks
        .filter((track)=> { return track.type == 'variant'; })
        .sort((a, b)=> { return a.bandwidth - b.bandwidth; })
        .pop();
    console.log('Offline Track bandwidth: ' + found.bandwidth);
    return [ found ];
  }
  
   initStorage(player) {
    console.log("inside of initStorage")
    // Create a storage instance and configure it with optional
    // callbacks. Set the progress callback so that we visualize
    // download progress and override the track selection callback.
    window.storage = new shaka.offline.Storage(player);
  //  console.log("after storage..")
    window.storage.configure({
      offline: {
        progressCallback: this.setDownloadProgress,
        trackSelectionCallback: this.selectTracks
      }
    });
  }
  
   listContent() {
    return window.storage.list();
  }
  
   playContent(content) {
    window.player.load(content.offlineUri);
  }
  
   removeContent(content) {
    return window.storage.remove(content.offlineUri);
  }
  
   downloadContent(manifestUri, title) {
    // Construct a metadata object to be stored along side the content.
    // This can hold any information the app wants to be stored with the
    // content.
    const metadata = {
      'title': title,
      'downloaded': Date()
    };
  
    return window.storage.store(manifestUri, metadata);
  }
  
  /*
   * UI callback for when the download button is clicked. This will
   * disable the button while the download is in progress, start the
   * download, and refresh the content list once the download is
   * complete.
   */
   onDownloadClick() {
   this.toastr.success("content downloading..")
    const downloadButton = this.downloadButton.nativeElement;
    const manifestUri = this.asseturiinput.nativeElement.value;
    console.log("manifestUri:"+manifestUri);
    const title =this.assettitleinput.nativeElement.value;
  console.log("title:"+title)
    // Disable the download button to prevent user from requesting
    // another download until this download is complete.
    downloadButton.disabled = true;
  
    this.setDownloadProgress(null, 0);
  
    // Download the content and then re-enable the download button so
    // that more content can be downloaded.
    this.downloadContent(manifestUri, title)
      .then(()=> {
        return this.refreshContentList();
      })
      .then((content) =>{
        this.setDownloadProgress(null, 1);
        this.toastr.success("successfully downloaded");
        downloadButton.disabled = false;
      })
      .catch((error) =>{
        // In the case of an error, re-enable the download button so
        // that the user can try to download another item.
        downloadButton.disabled = false;
        this.toastr.error("downloadig failed..")
        this.onError(error);
      });
  }
  
  /*
   * Update the online status box at the top of the page to tell the
   * user whether or not they have an internet connection.
   */
   updateOnlineStatus() {
    const signal = document.getElementById('online-signal');
    if (navigator.onLine) {
      signal.innerHTML = 'ONLINE';
      signal.style.background = 'green';
    } else {
      signal.innerHTML = 'OFFLINE';
      signal.style.background = 'grey';
    }
  }
  
  /*
   * Find our progress bar and set the value to show the progress we
   * have made.
   */
   setDownloadProgress(content, progress) {
//    const progressBar =this.progressbar.nativeElement;
 //   progressBar.value = progress * progressBar.max;
  }
  
  /*
   * Clear our content table and repopulate it table with the current
   * list of downloaded content.
   */
   refreshContentList() {
    const contentTable = this.contenttable.nativeElement;
  
    // Clear old rows from the table.
    while (contentTable.rows.length) {
      contentTable.deleteRow(0);
    }
  
    const addRow = (content) =>{
      const append = -1;
  
      const row = contentTable.insertRow(append);
      row.insertCell(append).innerHTML = content.offlineUri;
      Object.keys(content.appMetadata)
          .map((key)=> {
            return content.appMetadata[key];
          })
          .forEach((value)=> {
            row.insertCell(append).innerHTML = value;
          });
  
      row.insertCell(append).appendChild(this.createButton(
          'PLAY',
          ()=> { this.playContent(content); }));
  
      row.insertCell(append).appendChild(this.createButton(
          'REMOVE',
          () =>{
            this.removeContent(content)
                .then(() =>{ this.refreshContentList() });
          }));
    };
  
    return this.listContent()
        .then((content) =>{ content.forEach(addRow); });
  };
  
  /*
   * Create a new button but do not add it to the DOM. The caller
   * will need to do that.
   */
   createButton(text, action) {
    const button = document.createElement('button');
    button.innerHTML = text;
    button.onclick = action;
    return button;
  }
  
//  document.addEventListener('DOMContentLoaded', initApp);
  
}

